/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { GetwebService } from '../../dataservices/web/getweb.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { GetService } from '../../dataservices/get.service';
/**
 * Constant import.
 */
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { PRODUCT_TYPE_CONSTANT, GRADIENT_DIRECTION, NUMBERS, TEMPLATE_TYPE, CREATE_STORY_TYPES, STORY_CREATION_TYPE, REPOST_TYPE_ITEM, POSTING_PROGRESS, REPOST_STATUS, POST_TYPE, REPOST_INFO_LOCAL_STORAGE, SCREEN_NAME, USER_STORY_NUDGE, COMMENT_LIST_TYPE, LANG_ABBREVIATIONS, PRODUCT_TYPE_CONSTANT_NAME, CTA_TYPE, ACTION_TYPE, ACTION_ON } from '../../constants/app.constants';
import { CommunityObject } from '../../onboarding/interface/global.model';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Constant imports
 */
import { CALLING_FROM } from '../../constants/app.constants';
import {  CLICK_SUB, LIKE } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';


/**
 * Clinical Resource Card Component
 */
@Component({
  selector: 'app-clinical-resource-card',
  templateUrl: './clinical-resource-card.component.html',
  styleUrls: ['./clinical-resource-card.component.scss']
})
export class ClinicalResourceCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() callingfrom;
  @Input() clinicalObj;
  @Input() listLength;
  @Input() idx;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public ngbDDL: any;
  public likeObj; // Like Component Object
  public showLikeListModal = false;
  public bookmarkObj;
  public is_bookmark = false;
  public feed_like_loader = false;
  public feed_bookmark_loader = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe_obj: any;
  public showSubscribeModal = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public verifymodaljournalerror: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Output is used to emit specialty of card.
   */
  @Output() feedSpecialty = new EventEmitter();

  /**
   * Input screent name from which that card is called.,
   */
  @Input() screenName?: string;
  /**
   * EC id if user open it from ec card.
   */
  @Input() ecId?: number;

  @Input() parentEntityType: string;
  @Input() parentEntityCode;
  /**
   * Session time for analytics.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Product type constants.
   */
  public productType = PRODUCT_TYPE_CONSTANT;

  /**
   * Gradient direction constants.
   */
  public gradientDirection = GRADIENT_DIRECTION;

  /**
   * Number constants.
   */
  public numbers = NUMBERS;

  /**
   * Used to store calling from constant value.
   */
  public callingFrom = CALLING_FROM;
  /**
   * Key used to get comment list type.
   */
  public commentListType = COMMENT_LIST_TYPE;

  /**
   * Community Object for comment on GR.
   */
   public commentObj : CommunityObject ;
   /**
    * Used for comment typing.
    */
   public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
   /**
    * Constant for screen names
    */
   public screen = SCREEN_NAME;

  public createStoryScreen =  SCREEN_NAME.CREATE_USER_STORY;
  /**
   * Repost info popover status.
   */
  public showRepostPopOver = false;
  public isMetaGenerated = false;

  /**
   * Create post screen name.
   */
  public createRepostScreen = SCREEN_NAME.CREATE_REPOST;
  /**
   * create user story screen
   */
  public createUserStoryScreen = SCREEN_NAME.CREATE_USER_STORY;
  /**
   * Track if lang is es (Spanish)
   */
  public isLangEs = false;



  constructor(
    private masterService: MasterserviceService,
    public multiLangService: MultiLangService,
    private getwebService: GetwebService,
    private router: Router,
    public fcs: FunCollectionService,
    public postSer: PostApiService,
    public jwtSer: JwtDecodeService,
    private dss: DataStorageService,
    public mls: NewLanguageService,
    public igs: ImageGroupService,
    private getSer: GetService,
    private analyticSdk: Analytics
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (localStorage.getItem('lang') === LANG_ABBREVIATIONS.SPANISH) {
      this.isLangEs = true;
    }
    this.commentObj = {
      'product_id': this.clinicalObj.id,
      'product_type': NUMBERS.THREE,
      'comment': this.clinicalObj['comment_list'],
      'comment_count': this.clinicalObj['comment_count'],
      'kind': this.clinicalObj['feed_kind']
     };
     /**
      * Assigning product type and product id for article.
      */
     this.comment_box_obj.product_type_id = PRODUCT_TYPE_CONSTANT.ARTICLE_STRING;
     this.comment_box_obj.product_id = this.clinicalObj.id;

    if (this.clinicalObj.channel != null) {
      this.subscribe_obj = {
        'target_id': this.clinicalObj.channel.target_id,
        'channel_name': this.clinicalObj.channel.title,
        'tnc_url': this.clinicalObj.channel.safe_url,
        'target_name': this.clinicalObj.channel.powered_name,
        'target_label': this.clinicalObj.channel.powered_by_label,
        'publication_logo': this.clinicalObj.channel.channel_logo,
        'sponsor_footer_text': this.clinicalObj.channel.sponsor_footer_text,
        'no_of_members': this.clinicalObj.channel.no_of_members,
        'safe_url': this.clinicalObj.channel.safe_url,
        'product_view': this.clinicalObj.channel.is_product_view,
        'calling_from': 'clinical_notes_list',
        'target_id_clinical_detail': this.clinicalObj.id
      };
    }
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.initializeNgbDdl();
  }

  /**
   * initializeNgbDdl
   */
  initializeNgbDdl(): void {
    this.ngbDDL = {
      class: 'm', calling_from: 'clinical card',
      data: [
        { index: 0, action: 'report', text: this.mls.languageText.clinical_resource_card.key16, product_type: 3, product_type_id: this.clinicalObj.product_type_id },
      ]
    };
  }

  /**
   * navigate To detail
   */
  navigateTodetail(id): boolean {
    if (this.parentEntityType && this.parentEntityCode) {
      const clickData: CLICK_SUB = {
        entity_type: this.parentEntityType,
        entity_code: this.parentEntityCode,
        sub_entity_type: PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,
        sub_entity_code: this.clinicalObj.product_type_id,
        current_screen_name: this.fcs.currentScreename,
        action_on: ACTION_ON.REFERENCE,
        action_type: ACTION_TYPE.CLICK,
        cta_type: CTA_TYPE.SUB_CARD,
        start_time: new Date().getTime(),
        rank: 0
      };
      this.analyticSdk.analyticService.CLICK_SUB(clickData);
    }
    else {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.REFERENCE, null );
    }
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    if (this.clinicalObj.channel == null) {

      if (this.clinicalObj.content_type == 'docquity') {
        if (this.ecId) {
          this.router.navigateByUrl(`clinical/detail/${id}/${this.ecId}`);
        } else {
          this.router.navigateByUrl(`clinical/detail/${id}`);
        }
      } else {
        this.clinicalDetail(id);
      }
    } else if (this.clinicalObj.channel.is_subscribed == 0 && this.clinicalObj.channel.is_product_view == 0) {
      this.showSubscribeModal = true;

    } else if (this.clinicalObj.channel.is_product_view == 1 || this.clinicalObj.channel.is_subscribed == 1) {

      if (this.clinicalObj.content_type == 'docquity') {
        if (this.ecId) {
          this.router.navigateByUrl(`clinical/detail/${id}/${this.ecId}`);
        } else {
          this.router.navigateByUrl(`clinical/detail/${id}`);
        }
        return;
      } else {
        this.clinicalDetail(id);
      }
    }
    // tslint:disable-next-line: deprecation
    event.stopPropagation();
  }


  /**************Like Section****************************************/
  // this will call, click on like members of feed

  /**
   * product Like
   */
  productLike(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.feed_like_loader == true) { return; }
    if (this.clinicalObj.is_liked == true) { return; }
    this.feed_like_loader = true;
    this.subscriptions.add(this.postSer.productLike(this.clinicalObj.product_type, this.clinicalObj.id, 'like').subscribe(resData => {
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.clinicalObj.is_liked = true;
          this.clinicalObj.like_count = this.clinicalObj.like_count + 1;
          if (this.dss.isStoryLikeShareEnabled === 1) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key11, this.mls.languageText.stories_tutorial.key12, USER_STORY_NUDGE.is_story_first_like_enabled);
            this.dss.isStoryLikeShareEnabled = 0;
          }
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        // Error Handling
        this.feed_like_loader = false;
      });
    }));
    const likeData:LIKE ={
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,
      entity_code: this.clinicalObj.product_type_id,
      current_screen_name: this.fcs.currentScreename,
      start_time: new Date().getTime(),
      cta_type: CTA_TYPE.ENGAGEMENT_BAR,
      action_type: ACTION_TYPE.CLICK,
      action_on: ACTION_ON.LIKE,
    }
    this.analyticSdk.analyticService.LIKE(likeData);
  }

  /**
   * get Product Like List
   */
  getProductLikeList(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.likeObj = { 'product_id': this.clinicalObj.id, 'product_type': this.clinicalObj.product_type, 'callLikeProperty': 'list' };
    this.showLikeListModal = true;
  }

  /**
   * product Share
   */
  productShare(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    const x = [{ share_url: '', share_contentt: this.clinicalObj.share_content, product_type: this.clinicalObj.product_type, product_type_id: this.clinicalObj.id }];
    this.fcs.productShare(x, this.callingfrom);
  }

  /**
   * reset Like
   */
  resetLike(): void {
    this.feed_like_loader = false;
    this.showLikeListModal = false;
  }

  /**
   * reset like list modal
   */
  resetLikeModalList(val): void {
    this.showLikeListModal = val['reset'];
    const likeAction = val['reaction']['action'];
    if (likeAction == 'set' && this.clinicalObj['like_status'] != 1) {
      // Check Condition for like
    }
  }

  /**
   * product Bookmark
   */
  productBookmark(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.feed_bookmark_loader = true;
    const action = (this.clinicalObj.is_bookmarked == false) ? 'add' : 'delete';
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null );
    this.subscriptions.add(this.postSer.productBookmark(this.clinicalObj.product_type, this.clinicalObj.id, action).subscribe(resData => {
      this.feed_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.masterService.bookmark_index.next(this.idx);
          this.clinicalObj.is_bookmarked = (action == 'add') ? true : false;
          this.fcs.showSuccess(data['msg'], 'Success');
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        // Handle Error
        this.feed_bookmark_loader = false;
      });
    }));
  }

  /**
   * reset Bookmark
   */
  resetBookmark(resetObj): void {
    this.feed_bookmark_loader = false;
    if (resetObj === 1) {
      this.clinicalObj.archive = 1;
    } else if (resetObj === 0) {
      this.clinicalObj.archive = 0;
      const temp = { feed_id: this.clinicalObj.d };
      this.getwebService.feed_unbookmarked.next(temp);
    }
    this.is_bookmark = false;
  }

  /**
   * reset Subscribe Modal
   */
  resetSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * reset NgbDDL Record
   */
  resetNgbDDLRecord(): void {
    // no need to define for report
  }

  /**
   * clinical Detail
   */
  clinicalDetail(id): void {
    this.subscriptions.add(this.getSer.getClinicalDetail(id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          const url = 'https://docquity.com/detect/refto.php?exUrl=' + this.clinicalObj.description;
          this.fcs.openUrlInNewTab(url);
          return;

          return;
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * Get speciality aligned with card.
   */
  getSpecialty(Sl): void {
    this.feedSpecialty.emit(Sl);
    this.dss.specialty_filter = Sl;
    this.router.navigate(['/web/list']);

    const dateObject = new Date();
    this.sessiontime.start_time = dateObject.getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null)
  }


 

  /**
   * returns the value of calling from
   */
  get isEditorsChoiceList(): boolean {
    return (this.callingfrom === CALLING_FROM.EC_DETAIL);
  }

  /**
   * repost wbinar as story
   */
    repostAsStory(): void {
      this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.ARTICLE;
      this.dss.user_story_productTypeId = this.clinicalObj.product_type_id;
      this.dss.create_Story_productData.next(this.clinicalObj);
      this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
      this.dss.storyType = CREATE_STORY_TYPES.REPOST;
      this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
      this.dss.create_Story.next(true);
    }
  /**
   * create story through nudge
   */
  createStoryThroughNudge(storyNudgeHeading, storyNudgeDisc, nudgeType ): void {
    this.dss.create_Story_productData.next(this.clinicalObj);
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
    this.dss.user_story_productTypeId = this.clinicalObj.product_type_id;
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.storyNudgeIcon = 'assets/images/webinar-nudge.png';
    this.dss.storyNudgeHeading = storyNudgeHeading;
    this.dss.storyNudgeDisc = storyNudgeDisc,
    this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key16;
    this.dss.story_nudge_type = nudgeType;
    this.dss.userStoryNudge.next(true);
  }
    /**
     * repost as story
     */
    repostArticleType(event): void {
      if (event === REPOST_TYPE_ITEM.REPOST_ON_FEED) {
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,
          this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_FEED, null);
        this.repostArticle();
      }
      else if (event === REPOST_TYPE_ITEM.REPOST_AS_STORY) {
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,
          this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null);
        if (this.dss.user_profile_data.profile.permission != 'all') {
          this.fcs.assignAssociation('');
          return;
        }
        this.repostAsStory();
      }
    }
    /**
     * Repost article card
     */
    repostArticle(): void {
      if(this.dss.post_process_obj.status === POSTING_PROGRESS.IN_PROGRESS){
        this.fcs.showError('', this.mls.languageText.feed_card_screen.key22);
        return;
      }
      this.dss.repostProductId = this.clinicalObj.product_type_id;
      this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.ARTICLE;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(1);
      this.dss.webinarRepostObject = this.clinicalObj;
      this. closeRepostTooltip();
    }
    /**
     * Close repost tooltip
     */
    closeRepostTooltip(): void {
      this.showRepostPopOver = false;
      this.setLocalStorageIsRepostPopover();
      this.subscriptions.add(this.postSer.logTutorialView(POST_TYPE.REPOST).subscribe(data =>{
        //
      })
      );
    }

    /**
     * Set the repopst info popover status in local storage.
     */
    setLocalStorageIsRepostPopover(): void {
      localStorage.setItem(REPOST_INFO_LOCAL_STORAGE.KEY, REPOST_INFO_LOCAL_STORAGE.VALUE);
    }
    /**
     * Emit the generated meta.
     */
    onGenerateMeta(status: boolean): void {
      this.isMetaGenerated = status;
    }
    /**
     * show repost types
     */
    generateMeta(): void{
      /**
       * Check for re-post on community post.
       */
      this.fcs.checkRepostPopOver(this.clinicalObj?.topic_community_flag,this.clinicalObj?.channel?.community_id, this.clinicalObj?.hl?.tcf);

      this.isMetaGenerated = true;
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.ARTICLE,this.clinicalObj.product_type_id,
        this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST, null);
    }
    /**
     * close posting meta
     */
    closeMeta(event): void{
      /**
       * Set re-post hide key to default page.
       */
      this.fcs.isShowFeedRepost = true;
      this.isMetaGenerated = false;
    }
    /**
     * Emit action on generated Meta.
     */
    onMeta(deepLink: string): void {
        // this.emitOnMeta.emit(deepLink);
    }


  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
